import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import VacationsPage from './pages/VacationsPage';
import LeavesPage from './pages/LeavesPage';
import ProfilePage from './pages/ProfilePage';
import SupervisorPage from './pages/SupervisorPage';
import AdminPage from './pages/AdminPage';
import ReportPage from './pages/ReportPage';
import HolidaysPage  from './pages/HolidaysPage';
import AuditPage     from './pages/AuditPage';
import { ConfirmContainer } from './components/shared/ConfirmDialog';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toaster } from 'react-hot-toast';

const PrivateRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'var(--gray-500)' }}>
      Cargando…
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/login" replace />;
  return children;
};

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  if (user) {
    if (user.role === 'admin') return <Navigate to="/admin" replace />;
    if (user.role === 'supervisor') return <Navigate to="/supervisor" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />

      {/* Empleado */}
      <Route path="/dashboard" element={<PrivateRoute roles={['employee']}><DashboardPage /></PrivateRoute>} />
      <Route path="/vacaciones" element={<PrivateRoute roles={['employee']}><VacationsPage /></PrivateRoute>} />
      <Route path="/permisos" element={<PrivateRoute roles={['employee']}><LeavesPage /></PrivateRoute>} />
      <Route path="/perfil" element={<PrivateRoute roles={['employee']}><ProfilePage /></PrivateRoute>} />

      {/* Supervisor — una ruta con wildcard, el componente lee la URL */}
      <Route path="/supervisor/*" element={<PrivateRoute roles={['supervisor']}><SupervisorPage /></PrivateRoute>} />

      {/* Admin — una ruta con wildcard, el componente lee la URL */}
      <Route path="/admin/*" element={<PrivateRoute roles={['admin']}><AdminPage /></PrivateRoute>} />
      {/* La ruta wildcard ya cubre /admin/departamentos, /admin/empleados, etc. */}
      <Route path="/admin/informes"  element={<PrivateRoute roles={['admin']}><ReportPage /></PrivateRoute>} />
      <Route path="/admin/feriados"   element={<PrivateRoute roles={['admin']}><HolidaysPage /></PrivateRoute>} />
      <Route path="/admin/auditoria" element={<PrivateRoute roles={['admin']}><AuditPage /></PrivateRoute>} />
      <Route path="/admin/informe" element={<PrivateRoute roles={['admin']}><ReportPage /></PrivateRoute>} />

      {/* Supervisor — rutas personales (vacaciones/permisos propios) */}
      <Route path="/supervisor/mis-vacaciones" element={<PrivateRoute roles={['supervisor']}><VacationsPage /></PrivateRoute>} />
      <Route path="/supervisor/mis-permisos"   element={<PrivateRoute roles={['supervisor']}><LeavesPage /></PrivateRoute>} />
      <Route path="/supervisor/perfil"         element={<PrivateRoute roles={['supervisor']}><ProfilePage /></PrivateRoute>} />
      <Route path="/supervisor/informes"       element={<PrivateRoute roles={['supervisor']}><ReportPage /></PrivateRoute>} />
      <Route path="/supervisor/informe"          element={<PrivateRoute roles={['supervisor']}><ReportPage /></PrivateRoute>} />
      <Route path="/supervisor/informes"        element={<PrivateRoute roles={['supervisor']}><ReportPage /></PrivateRoute>} />

      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <ToastContainer />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: { fontFamily: 'DM Sans, sans-serif', fontSize: 14, borderRadius: 10 },
            success: { iconTheme: { primary: '#16a34a', secondary: '#fff' } },
            error: { iconTheme: { primary: '#dc2626', secondary: '#fff' } },
          }}
        />
        <ConfirmContainer />
      </BrowserRouter>
    </AuthProvider>
  );
}
